import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { FloatingWindowComponent } from '../floating-window/floating-window.component';
import { ScanTagsListComponent } from '../scan-tags-list/scan-tags-list.component';

/**
 * Separate non-modal movable window "Scan #N — Tags" holding a {@link ScanTagsListComponent} that loads on open.
 * Admin-only, but gated by whoever opens it (the gallery card button), not here. Open it like
 * app-json-object-preview: signal-driven @if + (closed).
 */
@Component({
  selector: 'app-scan-tags-popup',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FloatingWindowComponent, ScanTagsListComponent],
  template: `
    <app-floating-window [title]="windowTitle()" (closed)="closed.emit()">
      <app-scan-tags-list [scanId]="scanId()" [autoLoad]="true"></app-scan-tags-list>
    </app-floating-window>
  `,
})
export class ScanTagsPopupComponent {
  readonly scanId = input.required<string>();
  readonly sequenceInBatch = input.required<number>();
  readonly closed = output<void>();

  protected readonly windowTitle = computed(() => $localize`Scan #${this.sequenceInBatch()}:sequenceInBatch: — Tags`);
}
